// John Eldhose 20180822
import { RestfulPost } from './Restful';

export async function deleteContact(data) {
  const cont = await RestfulPost('deleteContact', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return cont;
}



// WEBPACK FOOTER //
// ./src/Api/deleteContact.js